<template>
  <div class="h-100"    v-click-outside="unselectLabel">
    <div class="d-flex" ref="fadeWhenModelOpen" >
    <div class="search-bar-comm-style pt-2 col-md-6" style="display: flex;">
      <input
            type="text"
            class="rounded text-light search-bar"
            :placeholder="$t('Search label')"
            autocomplete="off" v-model="search" @input="displayFilteredLabels(false)"/>
      </div>
      <div class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
        <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;"  v-on:click="deleteLabel()">{{$t('Delete')}}</button>
        <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;" v-on:click.stop.prevent="editLabel()">{{$t('Edit')}}</button>
        <button class="btn btn-outline-primary m-2"  v-on:click.prevent="openAddLabel">{{$t('Add')}}</button>
      </div>
      </div>
    
    <div class="col-md-12 height-set-for-component" ref="fadeWhenModelOpen" style="width:100%;">
      <ul class="tags-display-ul p-0 active-tag" v-if="labelsList.length">
        <li id="tag_field" class='view-tags' v-for="label in labelsList" @click="activeLabelDetails = label" :key="label._id" :style="label.label_type == 'user_defined'?applyBorder(label):applyBackground(label)" :class="{activeclass: activeLabelDetails?activeLabelDetails._id === label._id:''}">
              <span
              >{{label.name}}</span>
        </li>
      </ul>
      <div style="font-size: 20px; margin-top: 8%; color: #686868;" v-else-if="labelsList.length==0 && search.length">{{$t('No results found for searched keyword')}}</div>
      <div style="font-size: 20px; margin-top: 8%; color: #686868;" v-else-if="labelsList.length==0">{{$t('No data found')}}</div>
    </div>
    <div>
      <pagination
        v-model="page"
        :records="totalTags"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
      />
    </div>
    <div v-if="modalType">
      <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header p-2">
                      <h6 class="modal-title">{{modalType == 'add'?$t('Add Label'):$t('Edit Label')}}</h6>
                      <button
                          class="close text-white"
                          data-dismiss="modal"
                          aria-label="Close"
                          v-on:click="modalType = null"
                          title="Close"
                          >
                          <span aria-hidden="true">
                              <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                  width: 30px !important;
                                  color: #fff;">
                              </cancel-icon>
                          </span>
                      </button>
                  </div>
                  <div class="modal-body">
                    <div class="common-input-field">
                      <div style="display:flex;align-items:center;justify-content:space-between;">
                          <label>{{$t('Label name')}} <span style="font-size: 15px;">*</span></label>
                          <div v-if="modalType == 'edit' && activeLabelDetails && activeLabelDetails._id" class="label-id-copy-wrapper">
                            <span class="label-id-copy-icon" :title="$t('Click to copy label ID')" @click.stop.prevent="copyLabelId(activeLabelDetails._id)">
                              <svg viewBox="0 0 24 24" width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6"/>
                                <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6"/>
                              </svg>
                            </span>
                          </div>
                      </div>
                      <div v-if="modalType && modalType == 'edit' && !isEditting('labelName')" class="comm-edit-mode-style">
                        <div>{{labelName}}</div>
                        <svg v-on:click="enterIntoEditMode('labelName')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill edit-icon" viewBox="0 0 16 16">
                            <title>{{$t('Edit')}}</title>
                            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                        </svg> 
                    </div>
                    <div v-else-if="modalType && modalType == 'add' || isEditting('labelName')" style="display:flex;align-items: center">
                      <input
                          type="text"
                          class="rounded text-light comm-input-field-style"
                          style="padding-inline-end: 4%;"
                          tabindex="3"
                          ref="fieldSelectionRef"
                          placeholder="Enter label name"
                          autocomplete="off"
                          v-model="labelName"
                      />
                        <template v-if="modalType && modalType == 'edit'">
                        <svg v-on:click.stop.prevent="updateSelectedLabel('labelName')" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                        <svg v-on:click="editEnabledField = null" width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                        </template>
                      </div>
                    </div>
                    <div class="common-input-field" style="margin-top: 20px;">
                        <div>
                          <label>{{$t('Label Type')}} <span style="font-size: 15px;">*</span></label>
                        </div>
                        <div style="display:flex;flex-direction:column">
                          <div class="d-flex" style="align-items: center;margin-top:15px">
                            <input @click="modalType == 'edit'?updateSelectedLabel('labelType','user_defined'):''" type="radio" value="user_defined" v-model="labelType" class="bg-transparent border rounded text-light bigger-checkboxes" name="file path"/>
                            <label class="filter-label">User defined</label>
                          </div>
                          <div class="d-flex" style="align-items: flex-start;margin-top:15px">
                            <input @click="modalType == 'edit'?updateSelectedLabel('labelType','system_defined'):''" type="radio" value="system_defined" v-model="labelType" class="bg-transparent border rounded text-light bigger-checkboxes" name="file path"/>
                            <label class="filter-label">
                              <div>{{$t('System defined')}}</div>
                              <div class="config-desc">{{$t('System defined labels will be used in media pipeline, deletion of these labels will affect pipeline workflow')}}</div>
                            </label>
                          </div>
                        </div>
                     </div>   
                      <div class="common-input-field" style="margin-top: 20px;">
                        <div>
                            <label>{{$t('Color')}} <span style="font-size: 15px;">*</span></label>
                        </div>
                        <div style="display:flex;justify-content: start;flex-flow: wrap;">
                            <div v-for="color in colorPickers" :key="color" @click="selectedColor = color,modalType == 'edit'?updateSelectedLabel('color'):''" :style="'background:'+color" style="min-height:30px;min-width:30px; margin-inline-end:5px;border-radius:15px;margin-bottom:5px;display: flex;justify-content: center;align-items: center;" class="add-border-on-hover">
                                <svg v-if="selectedColor == color" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" class="bi bi-check2" viewBox="0 0 16 16" style="background: #282525c2;border-radius: 10px;">
                                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                  </svg>
                            </div>
                        </div>
                      </div>
                  </div>
                  <div v-if="modalType != 'edit'" class="modal-footer p-0 primary-btn-style">
                      <button @click="modalType = null" data-dismiss="modal" class="btn btn-outline-secondary mr-2">{{$t('Cancel')}}</button>
                      <button class="btn btn-outline-primary ml-1" @click="updateSelectedLabel()">
                          {{$t('Save')}}
                      </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import Pagination from "vue-pagination-2";
import {NotifierConstants} from "../../components.constants.js";
import cancelIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";

export default {
  name:'Labels',
  data(){
    return {
      labelsList: [],
      search: "",
      editedTagName: "",
      page: 1,
      totalPages: -1,
      totalTags: -1,
      perPage: -1,
      modalType: null,
      activeLabelDetails:null,
      isEditTag:false,
      options:{chunk:5},
      allOptionsList:[],
      selectedModalComponent:null,
      showEditDeleteIcons:null,
      editEnabledField:null,
      colorPickers:[
      "#DB2828","#F2711C","#FBBD08","#B5CC18","#21BA45","#00B5AD","#2185D0","#6435C9","#A333C8","#E03997", "#FFFFFF", "#000000" ,"#808080" ,"#C0C0C0"],
      selectedColor: "#B5CC18",
      labelType:'user_defined',
      labelName:'',
    };
  },
  components:{
    pagination: Pagination,
    'cancel-icon':cancelIcon
  },
  computed:{
    tagDetails(){
      return {tagInfo:this.activeLabelDetails}
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    paginate(page) { 
      // this.page = page;
      this.filteredLabels(true);
    },
    cancelTagEditField(){
      this.editedTagName = ""
      this.selectedTagId = null
      this.activeLabelDetails = null
      this.activeLabelDetails={};
    },
    unselectLabel(){
      this.activeLabelDetails = null;
    },
    enterIntoEditMode(field){
      this.editEnabledField = field;
    },
    isEditting(keyName) {
      return keyName === this.editEnabledField;
    },
    updateSelectedLabel(keyname,value){
      if(this.labelName.trim().length == 0){
            alert("Label name is empty !");
            return false;
        }
      if(this.modalType == 'add'){
        let payload = {
          'name': this.labelName,
          'label_type': this.labelType,
          'color': this.selectedColor
        }
        this.addNewLabel(payload).then((data) => {
          if(data.statusCode == 200){
            if('message' in data){
              this.$toast.success(data.message)
            }else{
              this.$toast.success('Created')
            }
          }else{
            this.$toast.error(data.message)
          }
          this.modalType = null;
        });
      }else if(this.modalType == 'edit'){     
        let payload = {};
        if(keyname == 'labelName'){
          payload['name'] =  this.labelName
        }  
        if(keyname == 'labelType'){
          payload['label_type'] =  value
        }    
        if(keyname == 'color'){
          payload['color'] =  this.selectedColor
        } 
        payload.params ={_id:this.activeLabelDetails._id}
        this.updateExistingLabel(payload).then((data) => {
          if(data.statusCode == 200){
            if('message' in data){
              this.$toast.success(data.message)
            }else{
              this.$toast.success('Updated')
            }
          }else{
            this.$toast.error(data.message)
          }
          this.modalType = null;
        });
      }
    },
    applyBorder(label){
      return {'border':'2px solid'+label.color+'!important','color':label.color}
    },
    applyBackground(label){
      return {'background':label.color+'!important','color':Utils.textColor(label.color)}
    },
    openAddLabel(){
      this.modalType = 'add';
      this.activeLabelDetails = null;
      this.labelName = '';
    },
    closeModal(){
      this.selectedModalComponent = null;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    closeAddTagModal(){
      this.modalType = null;
      this.search = "";
      this.filteredLabels(false);
    },
    closeEditTagModal(){
      this.cancelTagEditField();
      this.isEditTag=false;
      this.activeLabelDetails = null
      this.displayFilteredLabels();
    },
    setFocusToInputField(tagId){
      this.$nextTick(() => {
        const editIconRef = this.$refs[tagId];
        editIconRef[0].focus();
      });
    },
    editTagNameField(tagId, tagName) {
      this.editedTagName = tagName;
      this.selectedTagId = tagId;
      this.setFocusToInputField(tagId)
    },
    selectTag(id,name){
      this.editedTagName = "";
      this.selectedTagId = null;
      this.activeLabelDetails = id;
      this.activeLabelDetails = {"name":name,"id":id};
    },
    editLabel(){
      if(this.activeLabelDetails._id != undefined){
        this.modalType = 'edit';
        this.labelName = this.activeLabelDetails.name;
        this.labelType = this.activeLabelDetails.label_type;
        this.selectedColor = this.activeLabelDetails.color;
      }else{
        alert("Select label to edit");
        return false;
      }
    },
    deleteLabel(){
      if(this.activeLabelDetails){
        if(confirm(`Are You sure you want to delete the selected '"${this.activeLabelDetails.name}"' label ?`)){
          let payload = {_id:this.activeLabelDetails._id}
            this.deleteExistingLabel(payload).then((data)=>{
              if (data.statusCode==200){
                let tIdx = this.labelsList.findIndex(v => v._id === this.activeLabelDetails._id);
                if(tIdx >= 0){
                  this.labelsList.splice(tIdx, 1)
                }
                this.$toast.success(data.message);
                }else{
                  this.$toast.error(data.message);
                }
            });
            this.activeTagDetails=null;
        }
      }else{
        alert("Select label to delete");
        return false;
      }
    },
    displayFilteredLabels(){
      let payload ={}
      if(this.search.length > 0){
        payload.params = {name:this.search};
        this.getAllLabelsFromServer(payload).then((data) => {
          this.labelsList = data["labels"];
          this.page= 1;
          this.totalPages= -1;
          this.totalTags= -1;
          this.perPage= -1;
        });
      }else{
        this.filteredLabels(false)
      }
      
    },
    add_to_labelsList(labelInfo){
      let label_exists = this.labelsList.filter((tag)=>tag._id==labelInfo._id)
      if (label_exists.length ==0){
        this.labelsList.push(labelInfo)
      }else{
        Object.assign(label_exists[0], labelInfo)
      }
    },
    filteredLabels(isPageClick = false){
      this.$nextTick(() => {
          let payload ={}
          let paramsInfo = {}
          if(isPageClick){
            paramsInfo['page'] = this.page
          }
          payload = {params:paramsInfo}
          this.getAllLabelsFromServer(payload).then((data) => {
            this.labelsList = data["labels"];
            this.totalPages = data["page_count"];
            this.totalTags = data["total_labels"];
            this.perPage = data["labels_per_page"];
          });
      });
    },
    handleLabelNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let label_info = notification.message
        if (notification.message_type == NotifierConstants.labelDeleted){
          this.labelsList = this.labelsList.filter((tag)=>tag._id!=label_info._id)
        }else{
          this.add_to_labelsList(label_info)
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.labelCreated, NotifierConstants.labelUpdated, NotifierConstants.labelDeleted],
            callback:this.handleLabelNotification,
            parent:"labelsConfig"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.labelCreated, NotifierConstants.labelUpdated, NotifierConstants.labelDeleted],
            callback:this.handleLabelNotification,
            parent:"labelsConfig"})
    },
    copyLabelId(labelId){
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(labelId).then(() => {
          if(this.$toast){
            this.$toast.info(this.$t ? this.$t('Label id copied') : 'Label id copied');
          }
        }).catch(() => {
          this.fallbackCopyLabelId(labelId);
        });
      } else {
        this.fallbackCopyLabelId(labelId);
      }
    },
    fallbackCopyLabelId(labelId){
      try {
        const tempInput = document.createElement("textarea");
        tempInput.value = labelId;
        tempInput.setAttribute("readonly", "");
        tempInput.style.position = "absolute";
        tempInput.style.left = "-9999px";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        if(this.$toast){
          this.$toast.info(this.$t ? this.$t('Label id copied') : 'Label id copied');
        }
      } catch (err) {
        if(this.$toast){
          this.$toast.error(this.$t ? this.$t('Unable to copy label id') : 'Unable to copy label id');
        }
      }
    },
    ...mapActions("label", ["getAllLabelsFromServer", "getLabelsAutocomplete","addNewLabel","updateExistingLabel","deleteExistingLabel"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created(){
    this.registerforWebsocketNotifications()
    this.filteredLabels(false)
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.border-style{
  border: $border-color !important;
}
.activeclass{
  box-shadow: 1px 0px 1px 5px #6e6e6ebf !important;
}
.view-tags {
  font-size: 12px !important;
  height: 30px !important;
  display: flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  /* padding: 0 !important; */
  text-align: center;
  width: auto !important;
  /* padding-inline-start: 1px !important; */
  justify-content: center;
  /* padding-top: 4px !important; */
  align-items: center;
  border: 1px solid $tags-border-color!important;
  background: $tags-background-color;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}
.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover {
  border: $border-color !important;
}

.tags-display-ul{
  text-align:start;
  display:flex;
  flex-flow: wrap;
  li{
    margin-bottom:5px !important;
  }
}
.dropdown-item{
  padding:0px !important;
  width:13px !important;
}

.show-tags-delete {
  margin-inline-start: 1px;
  margin-inline-end: 5px;
}

.height-set-for-component{
  height:calc(100% - 150px);
  overflow:auto;
}
.search-bar-comm-style{
  margin-top: 5px;
  .search-bar{
    background: $primary-background !important;
    height:42px;
    width: 260px !important;
    float: inline-start;
    padding: 0px 12px 0 8px;
    padding-inline-start: 12px;
    border: $border-color !important;
  }
}

.primary-btn-style{
    text-align: end;
    button{
        height: 38px;
        width: 70px;
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.display-edit-delete-tags{
  display: none;
}

.view-tags:hover{
  .display-edit-delete-tags{
    display: flex;
  }
}
// //pagination
::v-deep {
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 5px;
            float:inline-end;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

.learn-about-text-styles{
  width: 158px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
    fill:$learn-about-text-color !important;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
  svg{
    fill:$learn-about-text-color-hover !important;
  }
}

.modal-dialog {
  max-width: 600px;
  width: 600px;
  margin: 0;
  padding: 0;
}

.modal{
  transition: opacity .3s ease;
}


.modal-content {
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
  background: $primary-background !important;
  border: $secondary-border-color;
  .modal-body{
      background: $primary-background;
      padding: 15px;
      display:flex;
      flex-direction:column;
  }
}
.modal-header,.modal-footer{
  border-top: $secondary-border-color !important;
  border-bottom: $secondary-border-color !important;
  background: $secondary-background-color;
  height: 58px;
  align-items: center;
  .modal-title{
      color:$text-color;
  }
}

.modal {
  text-align: center;
  padding: 0 !important;
  display: block;
  position: fixed;
  inset-inline-start: 0px;
  top: 15%;
}
.modal-header .close {
  margin: 0px !important;
  padding:0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100vh;
  vertical-align: middle;
  margin-inline-end: -4px;
  position: fixed;
  width: 100vw;
  inset-inline-start: 0;
  top: 0;
  background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.input-fields {
  border: $border-color !important;
  height:42px;
}

.input-fields:focus {
  outline: none;
  bottom: 0px;
  inset-inline-start: 0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

input[type="radio"] {
/* background-color only for content */
background-color:$primary-background !important;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
background-color: $active-blue !important;
//background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
border: 1px solid $active-blue !important;
}

input[type="radio"] {
outline: none !important;
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;
display: inline-block;
padding: 4px;
border-radius: 50% !important;
width: 20px;
height: 20px;
border: 1px solid #4a4a4a !important;
}

.filter-label{
position: relative;
bottom: 1px;
padding-inline-start:8px;
margin-bottom:0px !important;
display: flex;
width:100%;
flex-direction: column;
}

.config-desc{
color: $dull-text-color;
text-align:start;
margin-inline-end:8px;
}

.common-input-field{
display: inline-block;
width: 100%;
justify-content: space-between;
display: inline-block;
padding: 9px;
border-radius: 4px;
background: $primary-background;
border: $secondary-border-color !important;
label{
    width: 96%;
    color: $secondary-text-color;
}
input{
    flex:1;
}
}

.input-fields {
border: none !important;
border-bottom: 1px solid $active-blue !important;
height:30px;
}

.input-fields:focus {
outline: unset;
box-shadow:none;
}
.comm-input-field-style{
background: $primary-background!important;
width: 35% !important;
float: inline-start;
margin-top:8px;
padding: $input-field-padding;
border: $border-color!important;
font-size:$input-field-and-label-font-size;
height: $input-field-height;
}

input:focus,select:focus,textarea:focus{
outline: none;
--saf-0: rgba(var(--sk_highlight,18,100,163),1);
box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
border-radius: 4px;
border-color: transparent;
-webkit-appearance: none;
}

.add-border-on-hover:hover{
border: 2px solid #505050 !important;
}

.label-type-styles{
min-width: 23px;
border-radius: 18px;
height: 27px;
color: #000;
display: flex;
justify-content: center;
align-items: center;
position: relative;
inset-inline-end: 1px;
}

.comm-edit-mode-style{
display:flex;
align-items:center;
}

.comm-edit-mode-style:hover{
.edit-icon{
  visibility: visible;
}
}

.edit-icon{
visibility: hidden;
}

.edit-icon{
margin-inline-start: 5px;
}

.edit-icon:hover{
background: transparent;
border-radius: 0px;
}

.label-id-copy-wrapper{
display: flex;
align-items: center;
gap: 6px;
font-size: 12px;
color: $dull-text-color;
flex-shrink: 0;
margin-inline-start: 10px;

.label-id-text{
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  cursor: text;
  word-break: break-all;
}

.label-id-copy-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: $dull-text-color;
  user-select: none;

  &:hover{
    color: $active-blue;
  }
}
}
</style>